export const SUPPRESSION_NOTIFICATION_TYPE = 'SUPPRESSION';
export function isSuppressionSystemNotification(data) {
    if (!data.metadata || typeof data.metadata !== 'object') {
        return false;
    }
    const metadata = data.metadata;
    return (metadata.notificationType === SUPPRESSION_NOTIFICATION_TYPE &&
        metadata.interceptorName === 'channel-suppression');
}
//# sourceMappingURL=thread-events.js.map